/** Port of Views/Shared/_DataNotFound.cshtml, markup and image unchanged. */
export function DataNotFound(): JSX.Element {
  return (
    <div className="d-flex justify-content-center align-items-center text-center">
      <div className="col-12 col-md-4">
        <img src="/lib/images/datanotfound.jpg" alt="images" className="img-fluid" />
        <h4 className="no-data-title">Data Not Found</h4>
      </div>
    </div>
  )
}
